export default (that) => [
  {
    field: "seq",
    width: 50,
    align: "center",
    type: "seq",
    fixed: "left",
  },
  {
    title: that.$l("table-label-pjname") || "评价表名称",
    field: "appraisalBillName",
    minWidth: 200,
    align: "left",
    headerAlign: "center",
    showHeaderOverflow: "title",
  },
  {
    title: that.$l("label-status") || "状态",
    field: "appraisalBillStatus",
    minWidth: 120,
    align: "center",
    headerAlign: "center",
    showHeaderOverflow: "title",
    slots: { default: "status" },
  },
  {
    title: that.$l('INDEX.creator')||"创建人",
    field: "createByName",
    minWidth: 120,
    align: "center",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    title: that.$l('INDEX.create_date')||"创建时间",
    field: "createDate",
    width: 170,
    align: "center",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
    sortable: true,
    sortType: "string",
  },
  {
    title: that.$l('INDEX.table_label_modified_by')||"修改人",
    field: "modifyByName",
    minWidth: 120,
    align: "center",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
  },
  {
    title: that.$l('INDEX.table_label_modification_date')||"修改时间",
    field: "modifyDate",
    width: 170,
    align: "center",
    headerAlign: "center",
    showHeaderOverflow: "title",
    showOverflow: "ellipsis",
    sortable: true,
    sortType: "string",
  },
  {
    title: that.$l("INDEX.table_label_operation") || "操作",
    field: "col-opt",
    headerAlign: "center",
    fixed: "right",
    align: "center",
    width: 130,
    slots: {
      default: "opt",
    },
  },
]
